/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_StartInputs */

const en_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Journey`)
};

const ar_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ الرحلة`)
};

const de_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start der Reise`)
};

const es_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar el viaje`)
};

const fr_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer l'aventure`)
};

const it_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia il viaggio`)
};

const ja_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はじめる`)
};

const ko_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여정 시작하기`)
};

const pt_br_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar jornada`)
};

const ru_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать приключение`)
};

const th_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มต้นการเดินทาง`)
};

const tr_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yolculuğa Başla`)
};

const zh_cn_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始体验`)
};

const zh_tw_btn_start = /** @type {(inputs: Btn_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始體驗`)
};

/**
* | output |
* | --- |
* | "Start Journey" |
*
* @param {Btn_StartInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_start = /** @type {((inputs?: Btn_StartInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_StartInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_start(inputs)
	if (locale === "ar") return ar_btn_start(inputs)
	if (locale === "de") return de_btn_start(inputs)
	if (locale === "es") return es_btn_start(inputs)
	if (locale === "fr") return fr_btn_start(inputs)
	if (locale === "it") return it_btn_start(inputs)
	if (locale === "ja") return ja_btn_start(inputs)
	if (locale === "ko") return ko_btn_start(inputs)
	if (locale === "pt_br") return pt_br_btn_start(inputs)
	if (locale === "ru") return ru_btn_start(inputs)
	if (locale === "th") return th_btn_start(inputs)
	if (locale === "tr") return tr_btn_start(inputs)
	if (locale === "zh_cn") return zh_cn_btn_start(inputs)
	return zh_tw_btn_start(inputs)
});